import React from 'react';
import { MailIcon, PhoneIcon, MapPinIcon } from 'lucide-react';
export const Contact = () => {
  return <section id="contact" className="py-16" data-id="element-37">
      <div className="container mx-auto px-4" data-id="element-38">
        <div className="max-w-4xl mx-auto" data-id="element-39">
          <div className="text-center mb-12" data-id="element-40">
            <h2 className="text-3xl font-light text-stone-800 mb-2 inline-block border-b-2 border-red-700 pb-1" data-id="element-41">
              与我联系
            </h2>
            <p className="text-sm text-stone-500" data-id="element-42">交个朋友</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12" data-id="element-43">
            <div className="flex flex-col items-center p-6 bg-white rounded-lg shadow-sm border border-stone-100" data-id="element-44">
              <div className="w-12 h-12 bg-red-700/10 rounded-full flex items-center justify-center mb-4" data-id="element-45">
                <MailIcon size={24} className="text-red-700" data-id="element-46" />
              </div>
              <h3 className="text-lg text-stone-800 mb-2" data-id="element-47">Email</h3>
              <p className="text-stone-600 text-center" data-id="element-48"> panan521@qq.com</p>
            </div>
            <div className="flex flex-col items-center p-6 bg-white rounded-lg shadow-sm border border-stone-100" data-id="element-49">
              <div className="w-12 h-12 bg-red-700/10 rounded-full flex items-center justify-center mb-4" data-id="element-50">
                <PhoneIcon size={24} className="text-red-700" data-id="element-51" />
              </div>
              <h3 className="text-lg font-medium text-stone-800 mb-2" data-id="element-52">Phone</h3>
              <p className="text-stone-600 text-center" data-id="element-53">+86 18123838201</p>
            </div>
            <div className="flex flex-col items-center p-6 bg-white rounded-lg shadow-sm border border-stone-100" data-id="element-54">
              <div className="w-12 h-12 bg-red-700/10 rounded-full flex items-center justify-center mb-4" data-id="element-55">
                <MapPinIcon size={24} className="text-red-700" data-id="element-56" />
              </div>
              <h3 className="text-lg font-medium text-stone-800 mb-2" data-id="element-57">
                Location
              </h3>
              <p className="text-stone-600 text-center" data-id="element-58">中国-深圳</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};